import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [subscribed, setSubscribed] = useState(false);
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get('phone_alt') as string || '').trim();
    if (honeypotValue) {
      setFormStatus('success');
      setSubscribed(true);
      setFormMessage('订阅成功！感谢您的关注。');
      return;
    }

    setFormStatus('loading');
    setFormMessage('');

    try {
      formData.delete('phone_alt');
      const response = await fetch('https://readdy.ai/api/form/d9qq8s4nlsngrm4lm3sg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setSubscribed(true);
        setFormMessage('订阅成功！感谢您的关注，我们会定期发送最新瓜果资讯和优惠信息。');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormStatus('error');
          setFormMessage('提交失败，请稍后重试。');
        } else {
          setFormStatus('error');
          setFormMessage(serverMsg || '订阅失败，请稍后重试。');
        }
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请稍后重试。');
    }
  };

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-background-50 rounded-full">
                <i className="ri-store-2-line text-secondary-500 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">瓜瓜基地</span>
            </Link>
            <p className="text-sm text-background-50/80 leading-relaxed">
              正宗瓜果直采平台，从产地到餐桌，守护每一颗瓜的新鲜甜蜜。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4 text-background-50">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-50/75 hover:text-background-50 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category" className="text-sm text-background-50/75 hover:text-background-50 transition-colors cursor-pointer">瓜果分类</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/75 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/category?tab=articles" className="text-sm text-background-50/75 hover:text-background-50 transition-colors cursor-pointer">知识分享</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4 text-background-50">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-50/75">
                <i className="ri-phone-line"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/75">
                <i className="ri-mail-line"></i>
                <span>service@guaguabase.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/75">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>北京市朝阳区农展馆南路12号瓜瓜大厦</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/75">
                <i className="ri-time-line"></i>
                <span>周一至周日 9:00 - 21:00</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4 text-background-50">新鲜资讯</h4>
            {subscribed ? (
              <div className="bg-background-50/15 rounded-lg p-4 text-center">
                <i className="ri-checkbox-circle-line text-2xl text-accent-300"></i>
                <p className="text-sm mt-2 text-background-50">{formMessage}</p>
              </div>
            ) : (
              <form
                onSubmit={handleNewsletterSubmit}
                data-readdy-form=""
                id="newsletter-footer"
              >
                <p className="text-sm text-background-50/80 mb-3">订阅我们的资讯，第一时间获取最新瓜果上架和优惠活动信息。</p>
                <div className="relative">
                  <input
                    type="email"
                    name="email"
                    placeholder="请输入您的邮箱"
                    required
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-400"
                  />
                  <button
                    type="submit"
                    disabled={formStatus === 'loading'}
                    className="absolute right-1.5 top-1/2 -translate-y-1/2 px-4 py-1.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors disabled:opacity-60 whitespace-nowrap cursor-pointer"
                  >
                    {formStatus === 'loading' ? '订阅中...' : '订阅'}
                  </button>
                </div>
                <input
                  type="text"
                  name="phone_alt"
                  autoComplete="off"
                  tabIndex={-1}
                  aria-hidden="true"
                  readOnly
                  className="anti-spam-field"
                />
                {formStatus === 'error' && (
                  <p className="text-xs text-red-300 mt-2">{formMessage}</p>
                )}
              </form>
            )}
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/60">
            &copy; {new Date().getFullYear()} 瓜瓜基地 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/60">
            <a href="#" className="hover:text-background-50/90 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-50/90 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-background-50/90 transition-colors cursor-pointer">配送说明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}